<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      title: $t('ETAB.PAGES.RECRUITMENT.ACTIVATION.@MODAL_CARD_TITLE'),
    }"
    :card="{ class: 'creation-date-modal' }"
    size="xs"
    :quasar-props="{ maximized: false }"
    @before-show="beforeShow"
  >
    <template #body>
      <QList>
        <QItem v-for="card in cardsCollection.getCards()" :key="card.getId()" clickable @click="(e) => selectCard({ card })">
          <QItemSection avatar style="min-width: 0">
            <QIcon :color="isSelected({ card }) ? 'primary' : 'primary-lighter'" name="icon-f-credit-card" />
          </QItemSection>
          <QItemSection>
            <QItemLabel :class="{ 'text-primary-lighter': !isSelected({ card }) }">
              <span :class="{ 'text-bold': isSelected({ card }) }">{{ "XXXX XXXX XXXX " + card.getLast4() }}</span>
            </QItemLabel>
          </QItemSection>
        </QItem>
      </QList>
    </template>
    <template #footer>
      <QBtn
        color="positive"
        class="btn-navigation-half"
        :label="$t('ETAB.PAGES.RECRUITMENT.ACTIVATION.@MODAL_ADD_CARD_ACTION')"
        flat
        no-caps
        @click="$emit('onAddCard')"
      />
      <QBtn
        color="secondary"
        class="btn-navigation-half"
        no-caps
        :label="$t('ETAB.PAGES.RECRUITMENT.ACTIVATION.@MODAL_PAY_ACTION')"
        @click="$emit('onSelectAndPay', { selectedCard })"
      />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import { CardsCollectionModel, CardModel } from "@core/models";
  import { ExtracadabraModal } from "@core/components/modals";

  export default {
    components: {
      ExtracadabraModal,
    },
    props: {
      opened: {
        type: Boolean,
        default: false,
      },
      cardsCollection: {
        type: Object,
        default: () => new CardsCollectionModel(),
      },
    },
    emits: ["update:opened", "onAddCard", "onSelectAndPay"],
    data() {
      return {
        selectedCard: new CardModel(),
      };
    },
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set() {
          this.$emit("update:opened", false);
        },
      },
    },
    mounted() {
      this.beforeShow();
    },
    methods: {
      beforeShow() {
        this.selectedCard = new CardModel(this.cardsCollection.getDefaultCard());
      },
      isSelected({ card }) {
        return this.selectedCard.getId() === card.getId();
      },
      selectCard({ card }) {
        this.selectedCard = new CardModel(card);
      },
    },
  };
</script>

<style lang="scss">
  .payment-cards-list-modal {
    .q-item {
      @media screen and (max-width: 320px) {
        padding: 0 10px;
      }
    }
    .btn-navigation-half {
      margin: 0;
    }
  }
</style>
